export default __webpack_public_path__ + "static/media/logo.color.dark.6146962e.svg";